import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { RouterProvider } from 'react-router-dom'
import { StrictMode } from 'react'
import router from './router/router.tsx'
import { HelmetProvider } from '@dr.pogodin/react-helmet'
import { Provider } from 'react-redux'
import store from '@/globalStore/store.ts'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import { LicenseInfo } from '@mui/x-license'
import CssBaseline from '@mui/material/CssBaseline'
import ToastWrapper from '@/core/components/toast/ToastWrapper.tsx'
import './index.scss'
import ThemeProvider from '@/core/themeProvider/ThemeProvider.tsx'
import { env } from '@/env.ts'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'

import './config/zod'
import ExceptionlessWrapper from '@/core/components/exceptionless/Exceptionless.tsx'

LicenseInfo.setLicenseKey(env.VITE_APP_PUBLIC_MUI_X_LICENSE_KEY)

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } }
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <StrictMode>
    <ExceptionlessWrapper>
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Provider store={store}>
            <HelmetProvider>
              <CssBaseline />
              <ThemeProvider>
                <RouterProvider router={router} />
              </ThemeProvider>
              <ToastWrapper />
            </HelmetProvider>
          </Provider>
        </LocalizationProvider>
      </QueryClientProvider>
    </ExceptionlessWrapper>
  </StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
